import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setNextPage, setAuthenticatedUser } from "../../../shared/actions";
import LoadingSpinner from "../../../shared/components/LoadingSpinner";
import P from "../pages";
import Redirector from "../routes/Redirector";
import FirebaseCreateAccountForm from "./FirebaseCreateAccountForm";
import FirebaseEmailVerificationCheck from "../../../shared/components/Firebase/FirebaseEmailVerificationCheck";
import { useFeature } from "../../../shared/components/FeatureContext";
import withDefaults from "./withDefaults";

const FirebaseRegisterForm = ({ page, content, intl }) => {
  const authenticatedUser = useSelector(state => state.authenticatedUser)
  const dispatch = useDispatch()
  const urlParams = new URLSearchParams(window.location.search);
  const oobCode = urlParams.get("oobCode");
  const [checkingToken, setCheckingToken] = useState(false)
  const [emailVerified, setEmailVerified] = useState(oobCode ? false : null)

  const emailVerificationStandalone = useFeature("email_verification_standalone");
  const token = urlParams.get("token");

  const onEmailVerified = () => {
    dispatch(setNextPage(true))
  }

  useEffect(() => {
    if (Object.keys(authenticatedUser).length > 0) return

    const signInWithToken = async () => {
      setCheckingToken(true)
      try {
        const resp = await fetch("/users/sign_in_with_token", {
          method: "post",
          credentials: "same-origin",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content")
          },
          body: JSON.stringify({ token })
        })
        const data = await resp.json()
        if (data.success && data.authenticated_user) {
          dispatch(setAuthenticatedUser(data.authenticated_user))
          if (data.authenticated_user.email_verified) {
            dispatch(setNextPage(true))
          } else {
            setCheckingToken(false)
            setEmailVerified(false)
          }
        } else {
          setCheckingToken(false)
        }
      } catch (err) {
        console.error("Token login failed", err)
        setCheckingToken(false)
      }
    }

    const hydrateFromServer = async () => {
      // No token in URL; try to hydrate from server session
      const meResp = await fetch("/authenticated_users/me", {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content")
        }
      })

      if (!meResp.ok) {
        setCheckingToken(false)
        return
      }

      const meData = await meResp.json()
      if (meData.success && meData.authenticated_user) {
        dispatch(setAuthenticatedUser(meData.authenticated_user))
        if (meData.authenticated_user.email_verified) {
          dispatch(setNextPage(true))
        } else {
          setCheckingToken(false)
          setEmailVerified(false)
        }
      } else {
        setCheckingToken(false)
      }
    }

    if (token && !emailVerificationStandalone) {
      signInWithToken()
    } else {
      hydrateFromServer()
    }
  }, [])

  useEffect(() => {
    if (Object.keys(authenticatedUser).length == 0) return

    if (authenticatedUser.email_verified) {
      dispatch(setNextPage(true))
    } else {
      setCheckingToken(false)
      setEmailVerified(false)
    }
  }, [authenticatedUser])


  return (
    <>
      <Redirector this_page={P.FIREBASE_REGISTER_FORM_PAGE} page={page} />

      {checkingToken ? (
        <LoadingSpinner />
      ) : (
        <div className="register_form" style={{ display: checkingToken ? "none" : "block" }}>
          {emailVerified !== false ? (
            <FirebaseCreateAccountForm page={page} intl={intl} content={content} setEmailVerified={setEmailVerified} />
          ) : (
            <FirebaseEmailVerificationCheck intl={intl} subject="guest" onEmailVerified={onEmailVerified} />
          )}
        </div>
      )}
    </>
  );
};

FirebaseRegisterForm.propTypes = {
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object
};

export default withDefaults(FirebaseRegisterForm);
